module.exports = __webpack_public_path__ + "img/inspiration-4.c1fbf2e.jpg";